<template>
  <div class="inputSearch">

<InputSearch @getData="onInputChange" v-model="value" ref='search' @selected='selected' :columns='columns' :loading='loading'
   :autoFocus='true'     @on-blur='inputBlur' :data='options'  :reset='false'></InputSearch>
  </div>
</template>
<script>
// import hotkeys from 'hotkeys-js';
import goods from '../../services/goods';
import utils from '../../libs/utils';
import InputSearch from '../InputSearch.vue';

export default {
  name: 'goodsDropDown',
  components: { InputSearch },
  props: {
    val: {
      type: String,
    },
    // autoFocus: {
    //   type: Boolean,
    //   default: false,
    // },
    selectedList: {
      type: Array,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  model: {
    prop: 'val',
    event: 'change',
  },
  watch: {
    val() {
      this.value = this.val;
    },
    type() {

    },
  },
  computed: {
    columns() {
      if (this.type === 3) {
        return this.columnsDecoction;
      } if ([1, 2].includes(this.type)) {
        return this.columnsCommon;
      }

      return this.columnsOther;
    },
  },
  data() {
    return {
      value: '',
      visible: false,
      selectLoading: false,
      selectedIndex: null,
      loading: false,
      options: [],
      columnsDecoction: [
        {
          title: '药品通用名',
          key: 'approvedDrugNames',
          width: '80px',
        },
        {
          title: '规格',
          key: 'specifications',
          width: '50px',
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnitString',
          width: '30px'
        },
        {
          title: '产地',
          key: 'countryOfOrigin',
          width: '40px',
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          width: '80px',
        },
      ],
      columnsCommon: [
        {
          title: '药品通用名',
          key: 'approvedDrugNames',
          width: '80px',
        },
        {
          title: '批准文号/注册证号',
          key: 'approvalNumber',
          width: '120px',
        },
        {
          title: '规格',
          key: 'specifications',
          width: '50px',
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnitString',
          width: '30px'
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          width: '80px',
        },
      ],
      columnsOther: [
        {
          title: '药品通用名',
          key: 'approvedDrugNames',
          width: '80px',
        },
        // {
        //   title: '批准文号/注册证号',
        //   key: 'approvalNumber',
        //   width: '120px',
        // },
        {
          title: '规格',
          key: 'specifications',
          width: '50px',
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnitString',
          width: '30px'
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          width: '80px',
        },
      ],
    };
  },
  methods: {
    onInputChange(val) {
      console.log(111);

      this.$emit('change', this.value);

      if (val) {
        const data = {
          approvedName: val,
          statusCodeList: [1],
          page: 1,
          size: 100,
          type: this.type,
        };
        // this.$store.commit('setDisableLoading', true);
        this.loading = true;
        this.$store.commit('setDisableLoading', true);
        goods.listGoodsBases(data).then((res) => {
          // this.$emit('change', this.value);
          this.loading = false;
          if (res.data.status === 200) {
            // res.data
            this.options = [];
            const { list } = res.data.data;
            if (list.length) {
              list.forEach((item) => {
                const result = utils.deepClone(item.goodsBase);
                this.options.push(result);
              });
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.loading = false;
          utils.handleError(err);
        });
      } else {
        this.options = [];
        this.visible = false;
      }
    },
    // handleClick(){}
    // onDropDownclick(name) {
    //   console.log(name);

    //   if (this.selectLoading || name === 'title' || name === 'noTitle') {
    //     this.selectLoading = false;
    //     this.visible = false;
    //     this.$nextTick(() => {
    //       this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
    //     });
    //   } else {
    //     this.visible = true;

    //     this.selectLoading = true;

    //     if (!Number.isNaN(name)) {
    //       this.selectedIndex = name;
    //       this.seleced();
    //       this.$nextTick(() => {
    //         this.visible = false;
    //       });
    //     }
    //     setTimeout(() => {
    //       this.selectLoading = false;
    //     }, 500);
    //   }
    // },
    inputBlur() {
      this.$emit('on-blur', this.value);
      this.$nextTick(() => {
        this.visible = false;
      });
    },

    selected(val) {
      // this.visible = false;
      // console.log(this.options[this.selectedIndex]);

      this.$emit('selected', { goodsBase: val });
    },


  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
.searchList{
  max-height: 300px;
  overflow: auto;
  // width: 660px;

}
.selected{
  background: #f8f8f8
}
.noTitle{
  .noThing{
  height: 36px;
  line-height: 36px;
  padding-left: 16px;
  color: rgba(0, 0, 0, 0.25)
}

}
.options{
  // width: 660px;
  display: flex;
  align-items: center;
  font-size: 12px;
  >span{
    width: 22%;
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;

  }
  // >span:nth-child(1){
  //   width: 80px
  // }
  >span:nth-child(2){
    width: 180px
  }
  .textOver{
    width: 100%;
    text-align: center;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
